/**
 *
 * @type {{userConnected: null, myFavs: *[]}}
 * @private
 */

// State manager
const state = {
  myFavs: [],
  userConnected: null,
};

// Getters
const getters = {
  getMyFavs: () => state.myFavs,
  getUserConnected: () => state.userConnected,
};

// Asynchronous methods
const actions = {
  // setUserConnected(context) {
  //   context.commit('setUserConnected');
  // },
  setUserConnected({ commit }, context) {
    commit('SET_USER_CONNECTED', context);
  },
  appendFavs({ commit }, nid) {
    commit('APPEND_FAVS', nid);
  },
  removeFav({ commit }, nid) {
    commit('REMOVE_FAV', nid);
  },
  initFavs({ commit }, favs) {
    commit('INIT_FAVS', favs);
  },
};

/**
 * Synchronous methods
 * Used to change states
 */
const mutations = {
  SET_USER_CONNECTED(localState, connected) {
    const currentState = localState;
    currentState.userConnected = connected;
  },
  APPEND_FAVS(localState, nid) {
    const currentState = localState;
    currentState.myFavs.push(nid);
  },
  REMOVE_FAV(localState, nid) {
    const currentState = localState;
    const index = currentState.myFavs.indexOf(nid);
    if (index > -1) {
      currentState.myFavs.splice(index, 1);
    }
  },
  INIT_FAVS(localState, favs) {
    const currentState = localState;
    currentState.myFavs = favs;
  },
};

// export store module
export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
